import React, { useState, useEffect } from "react";

function FilesUpload({ formData, setFormData, researchAreas }) {
  const [mainDomain, setMainDomain] = useState("");
  const [subDomainOptions, setSubDomainOptions] = useState([]);

  useEffect(() => {
    // Update subdomain options based on the selected main domain
    if (mainDomain) {
      const selectedDomain = researchAreas.find(
        (domain) => domain.mainDomain === mainDomain
      );
      setSubDomainOptions(selectedDomain ? selectedDomain.subDomains : []);
    } else {
      setSubDomainOptions([]);
    }
  }, [mainDomain, researchAreas]);

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      fileURL: e.target.files[0],
    });
  };

  const handleDomainChange = (e, domainNumber) => {
    setFormData({
      ...formData,
      [domainNumber]: e.target.value,
    });
  };

  return (
    <div className="paper-submission-container">
      <div className="paper-upload-wrapper">
        
        {/* File Upload Section */}
        <div className="paper-upload-section">
          <div className="paper-upload-card">
            <div className="paper-upload-icon">
              <svg className="paper-file-icon" width="200" height="200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h3 className="paper-upload-title">Upload Paper Document</h3>
            <p className="paper-upload-description">
              Upload your research paper in PDF format (Max size: 10MB)
            </p>
            <div className="paper-file-input-container">
              <input
                type="file"
                required
                name="file"
                className="paper-file-input"
                id="paper-file-upload"
                onChange={handleFileChange}
                accept=".pdf,.doc,.docx"
              />
              <label htmlFor="paper-file-upload" className="paper-file-input-label">
                <span className="paper-file-input-text">
                  {formData.fileURL ? formData.fileURL.name : "Choose File"}
                </span>
              </label>
            </div>
          </div>
        </div>

        {/* Domain Selection Section */}
        <div className="paper-domain-section">
          <div className="paper-domain-header">
            <h3 className="paper-domain-title">Research Domain Classification</h3>
            <p className="paper-domain-description">
              Select the research domains that best describe your paper
            </p>
          </div>

          <div className="paper-domain-fields">
            <div className="paper-field-group">
              <label className="paper-field-label">
                <span className="paper-label-text">Main Domain</span>
                <span className="paper-required-mark">*</span>
              </label>
              <select
                id="paperDomain1"
                className="paper-select-field"
                value={formData.paperDomain1}
                onChange={(e) => {
                  setMainDomain(e.target.value);
                  handleDomainChange(e, "paperDomain1");
                }}
              >
                <option value="" disabled>
                  Select main research domain
                </option>
                {researchAreas.map((domain, index) => (
                  <option key={index} value={domain.mainDomain}>
                    {domain.mainDomain}
                  </option>
                ))}
              </select>
            </div>

            <div className="paper-domain-row">
              <div className="paper-field-group paper-field-half">
                <label className="paper-field-label">
                  <span className="paper-label-text">Sub Domain 1</span>
                  <span className="paper-field-optional">(Optional)</span>
                </label>
                <select
                  id="paperDomain2"
                  className="paper-select-field"
                  value={formData.paperDomain2}
                  onChange={(e) => handleDomainChange(e, "paperDomain2")}
                  disabled={!mainDomain}
                >
                  <option value="N/A">Not Applicable</option>
                  {subDomainOptions.map((subDomain, index) => (
                    <option key={index} value={subDomain}>
                      {subDomain}
                    </option>
                  ))}
                </select>
              </div>

              <div className="paper-field-group paper-field-half">
                <label className="paper-field-label">
                  <span className="paper-label-text">Sub Domain 2</span>
                  <span className="paper-field-optional">(Optional)</span>
                </label>
                <select
                  id="paperDomain3"
                  className="paper-select-field"
                  value={formData.paperDomain3}
                  onChange={(e) => handleDomainChange(e, "paperDomain3")}
                  disabled={!mainDomain}
                >
                  <option value="N/A">Not Applicable</option>
                  {subDomainOptions.map((subDomain, index) => (
                    <option key={index} value={subDomain}>
                      {subDomain}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FilesUpload;